<template>
  <div v-if="menuData.isVisible && $store.getters['PF/haveAccess']">
    <q-btn
      data-cy="btnOpenMenu"
      flat
      round
      dense
      @click="toggleMenu(isOpen)"
      :icon="isOpen ? 'close' : 'menu'"
      class="q-mr-sm"
    />
    <q-drawer
      side="left"
      v-model="isOpen"
      :width="256"
      :breakpoint="500"
      bordered
      class="bg-grey-3"
    >
      <div style="margin-top: 20px;"></div>
      <q-scroll-area visible style="width:100%; height: calc(80% - 43px)">
        <q-list class="text-primary listItems">
          <div v-for="(items, key) in menuData.data" :key="key">
            <span v-if="!items.items">
              <q-item
                style="margin-top: 5px; margin-bottom: 5px;"
                :data-cy="'itemMenu' + items.link.path"
                clickable
                v-ripple
                :class="[
                  'title-menu-section text-center',
                  items.disabled ? 'disabled' : '',
                  _checkActualPage(items) ? 'active-item' : ''
                ]"
                :key="key"
                :to="_getLink(items)"
              >
                <q-item-section avatar>
                  <q-icon
                    :class="items.icon.class"
                    :size="items.icon.size"
                    :name="'img:' + require('@/assets/' + items.icon.link)"
                    style="min-width: 30px;"
                    v-if="items.icon"
                  />
                </q-item-section>
                <q-item-section side class="text-label-item">
                  <q-item-label>{{ items.parentTitle }}</q-item-label>
                </q-item-section>
              </q-item>
            </span>

            <q-expansion-item
              v-else
              dense-toggle
              :icon="
                items.icon
                  ? 'img:' + require('@/assets/' + items.icon.link)
                  : ''
              "
              :label="items.parentTitle"
              class="title-menu-section text-left"
            >
              <q-item
                tag="a"
                data-cy="itemMenu"
                clickable
                v-ripple
                v-for="(item, key) in items.items"
                :class="[
                  item.disabled ? 'disabled' : '',
                  _checkActualPage(item) ? 'active-item' : ''
                ]"
                :key="key"
                :to="_getLink(item)"
              >
                <q-item-section avatar> </q-item-section>
                <q-item-section side class="text-label-item">
                  <q-item-label> {{ item.name }} </q-item-label>
                </q-item-section>
              </q-item>
            </q-expansion-item>
          </div>
        </q-list>
      </q-scroll-area>
    </q-drawer>
  </div>
</template>
<script>
import { QIcon, QScrollArea, QDrawer } from 'quasar';

export default {
  components: {
    QIcon,
    QScrollArea,
    QDrawer
  },
  data () {
    return {
      isOpen: false,
      menuData: {}
    };
  },
  props: {
    navigationMenu: {
      type: Object,
      default: function () {
        return {
          isVisible: true,
          data: [
            {
              parentTitle: 'Text to show',
              icon: {
                // Path from assets
                link: 'img/inbox.svg',
                size: '24px',
                class: 'imgCenter'
              },
              link: {
                type: 'name', // name, internal
                path: 'catalogo'
              }
            }
          ]
        };
      }
    }
  },
  methods: {
    toggleMenu (isOpen) {
      const newState = !isOpen;
      this.isOpen = newState;
    },
    _checkActualPage (i) {
      let hasParams = false;
      hasParams = Object.keys(this.$route.query).length > 0;

      if (hasParams) {
        return this.$route.fullPath === i.link.path;
      }
      return this.$route.path.startsWith(`/${i.link.path}`);
    },
    _getLink (object) {
      if (
        !object.link ||
        (object.hasOwnProperty('disabled') && object.disabled)
      ) { return; }

      const objLink = object.link;

      if (objLink.type === 'name') {
        return { name: objLink.path };
      }

      return objLink.path;
    },
    async _checkPermisos (data) {
      const dataMenu = data.data;
      if (dataMenu.length === 0) return;
      return data;
    }
  },
  watch: {
    navigationMenu: {
      handler: async function () {
        if (Object.entries(this.navigationMenu).length > 0) {
          this.menuData = await this._checkPermisos(this.navigationMenu);
        }
      },
      immediate: true
    },
    isOpen: {
      handler: function () {
        // Set mutation
        this.$store.commit('PF/refreshToggleMenu', this.isOpen);
      },
      immediate: true
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/css/style.scss";

a {
  text-align: left;
}

#separator {
  margin: 0px !important;
}

a.q-item.q-item-type {
  margin-top: 5px !important;
}
</style>
